import firebase from 'gatsby-plugin-firebase';

const deletePieChart = async (id: string): Promise<void> => {
  await firebase.database().ref(`/piechart/${id}`).remove();
};

export default deletePieChart;
